(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    (function() {
  document.querySelectorAll('.custom-lang-switcher').forEach(function(switcher) {
    var btn = switcher.querySelector('.custom-lang-switcher__btn');
    var list = switcher.querySelector('.custom-lang-switcher__list');
    var hiddenInput = switcher.closest('.language-selector').querySelector('.localization-form__select');
    var currentLabel = switcher.querySelector('.custom-lang-switcher__current');

    var isDesktopSwitcher = switcher.classList.contains('custom-lang-switcher--desktop');
    var closeTimer;

    function openList() {
      window.clearTimeout(closeTimer);
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');

      if (isDesktopSwitcher) {
        window.requestAnimationFrame(function() {
          list.classList.add('is-open');
        });
      }
    }

    function closeList(immediate) {
      btn.setAttribute('aria-expanded', 'false');
      list.classList.remove('is-open');
      window.clearTimeout(closeTimer);

      if (!isDesktopSwitcher || immediate) {
        list.hidden = true;
        return;
      }

      closeTimer = window.setTimeout(function() {
        list.hidden = true;
      }, 180);
    }

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        closeList(false);
      } else {
        openList();
      }
    });

    list.querySelectorAll('.custom-lang-switcher__item').forEach(function(item) {
      function selectLanguage() {
        var val = item.getAttribute('data-value');
        var label = item.getAttribute('data-label');
        hiddenInput.value = val;
        currentLabel.textContent = label;
        closeList(true);
        var form = hiddenInput.closest('form');
        if (form) form.submit();
      }

      item.addEventListener('click', selectLanguage);
      item.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectLanguage();
        }
      });
    });

    document.addEventListener('click', function() {
      closeList(false);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        closeList(false);
        btn.focus();
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
